import axios from 'axios';
import { getApiBaseUrl } from './apiBase';

const API_BASE_URL = getApiBaseUrl();
const API_URL = `${API_BASE_URL}/config`;

export const configService = {
  getPricingConfig: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/pricing`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    return response.data; // { success, config }
  },
  updatePricingConfig: async (payload) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_URL}/pricing`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data; // { success, config }
  },
  getStatusConfig: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/status`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    return response.data; // { success, config }
  },
  updateStatusConfig: async (payload) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_URL}/status`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data; // { success, config }
  },
  getBankDetails: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/bank`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    return response.data; // { success, bank }
  }
};
